export const PRE_LOGIN = `
mutation ($schoolCode: String!, $schoolPassword: String!) {
  preLogin(schoolCode: $schoolCode, schoolPassword: $schoolPassword) {
    schoolToken
  }
}`;

export const LOGIN = `
mutation($account: String!, $password: String!, $schoolToken: String!) {
  login(account: $account, password: $password, schoolToken: $schoolToken) {
    token
    account {
      id
      name
      isShowAnnualButton
      schoolName
      isPushAnnual
    }
  }
}`;

export const GET_ACCOUNT = `
query {
  account {
    id
    name
    phone
    avatar
    wechat
    isAvailable
    userTypeId
    createAt
    updateAt
  }
}`;

export const SIGN_IN = `
mutation {
  signIn {
    force
  }
}`;

export const UPDATE_ACCOUNT = `
mutation($studentName: String!, $studentPhone: String!, $studentGrade: String!, $studentClass:
  String!, $sex: Int, $age: Int, $region: String!, $email: String, $qq: String, $wechat: String) {
  updateAccount(studentName: $studentName, studentPhone: $studentPhone, studentGrade:
    $studentGrade, studentClass: $studentClass, sex: $sex, age: $age, region: $region, email:
    $email, qq: $qq, wechat: $wechat)
}`;

export const LOGOUT = `
mutation{
  logout {
    url
  },
}`;

export const REGISTER = `
mutation($phone: String!, $captcha: String!, $name: String!,
$password: String!, $schoolToken: String!) {
  register(phone: $phone, captcha: $captcha, name: $name,
  password: $password, schoolToken: $schoolToken)
}`;

export const SEND_SMS_CODE = `
mutation ($phone: String!, $type: String!) {
  sendCaptcha(phone: $phone, type: $type)
}`;

export const FORGET_PASSWORD = `
mutation ($phone: String!, $code: String!, $password: String!) {
  forgetPassword (phone: $phone, code: $code, password: $password)
}`;

export const FETCH_SCHOOL_TOKEN = `
mutation ($code: String!) {
  fetchSchoolToken(code: $code) {
    schoolToken
    isCanExperience
  }
}`;
